const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* GTG scroll restoration — staging hotfix 2026-09-18
 * Loaded from constants.js because it is always deferred in layout/theme.liquid.
 * Standalone copy: assets/gtg-scroll-restore.js (also referenced from gtg-ux-foot).
 * Fixes Back from footer links landing at top (Dawn #MainContent tabindex focus jump).
 */
(function () {
  if (window.__gtgScrollRestoreBound) return;
  window.__gtgScrollRestoreBound = true;

  var KEY_PREFIX = 'gtg:scroll:';
  var restoring = false;
  var restoreTimer = null;

  try {
    if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
  } catch (e) {}

  function pageKey() {
    return KEY_PREFIX + location.pathname + location.search;
  }

  function navType() {
    try {
      var entries = performance.getEntriesByType && performance.getEntriesByType('navigation');
      if (entries && entries[0] && entries[0].type) return entries[0].type;
    } catch (e) {}
    try {
      if (performance.navigation && performance.navigation.type === 2) return 'back_forward';
    } catch (e) {}
    return 'navigate';
  }

  function isBackForward() {
    return navType() === 'back_forward';
  }

  function hasHashTarget() {
    var h = location.hash;
    if (!h || h.length < 2) return false;
    try {
      return !!document.getElementById(decodeURIComponent(h.slice(1)));
    } catch (e) {
      return true;
    }
  }

  function save() {
    if (restoring) return;
    try {
      sessionStorage.setItem(pageKey(), String(Math.max(0, window.scrollY || window.pageYOffset || 0)));
    } catch (e) {}
  }

  function readSaved() {
    try {
      var raw = sessionStorage.getItem(pageKey());
      if (raw == null || raw === '') return null;
      var n = parseInt(raw, 10);
      return isNaN(n) ? null : n;
    } catch (e) {
      return null;
    }
  }

  function scrollToY(y) {
    if (y == null || y < 1) return;
    try {
      window.scrollTo(0, y);
    } catch (e) {
      try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (e2) {}
    }
  }

  function restore(y) {
    if (y == null || y < 1) return;
    if (hasHashTarget()) return;
    restoring = true;
    scrollToY(y);
    if (restoreTimer) clearTimeout(restoreTimer);
    var passes = [0, 50, 150, 400, 800];
    var i = 0;
    function tick() {
      scrollToY(y);
      i += 1;
      if (i < passes.length) {
        restoreTimer = setTimeout(tick, passes[i] - (passes[i - 1] || 0));
      } else {
        restoring = false;
      }
    }
    requestAnimationFrame(function () {
      scrollToY(y);
      restoreTimer = setTimeout(tick, passes[0]);
    });
  }

  function shouldRestore(persisted) {
    if (hasHashTarget()) return false;
    return !!(persisted || isBackForward());
  }

  function onPageshow(event) {
    try {
      if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
    } catch (e) {}
    if (!shouldRestore(!!event.persisted)) return;
    restore(readSaved());
  }

  function guardMainContentFocus() {
    var main = document.getElementById('MainContent');
    if (!main || main.__gtgScrollFocusGuard) return;
    main.__gtgScrollFocusGuard = true;
    main.addEventListener(
      'focus',
      function () {
        if (!shouldRestore(false) && !restoring) return;
        var y = readSaved();
        if (y == null) return;
        requestAnimationFrame(function () {
          scrollToY(y);
        });
      },
      true
    );
  }

  window.addEventListener('pagehide', save);
  window.addEventListener('beforeunload', save);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') save();
  });

  var scrollSaveTimer;
  window.addEventListener(
    'scroll',
    function () {
      if (restoring) return;
      clearTimeout(scrollSaveTimer);
      scrollSaveTimer = setTimeout(save, 120);
    },
    { passive: true }
  );

  window.addEventListener('pageshow', onPageshow);

  function boot() {
    guardMainContentFocus();
    if (shouldRestore(false)) restore(readSaved());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', function () {
    if (shouldRestore(false)) restore(readSaved());
  });
})();
